/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, createContext } from "react"
import StickyBox from "react-sticky-box"
import { useDispatch } from "react-redux"
import Header from "./header/header"
import Footer from "./footer/footer"
import Toaster from "./Toaster/toaster"
import { UserLoginBefore } from "../slices/userSlice"
import Tracking from "./tracking/tracking"
import withAppInstalled from "./apps/apps"
import LocationTrack from "./location/LocationTrack"
import { SearchServiceLocations } from "../slices/searchSlice"
import useRefreshData from "../hooks/useRefreshUserData"
import { ModalController, LayoutSearchModal } from "./searchModal"
import useSubscribeToEvents from "../hooks/useSubscribeToEvents"
import useNavHeight from "../hooks/useNavHeight"

const Layout = ({
  id,
  children,
  footerType,
  headerType,
  footerPage,
  serviceLocations,
  classNames,
}) => {
  const dispatch = useDispatch()

  //don't pass anymore props to this effect it will just trigger once on load
  useEffect(() => {
    //this must load during loader screen. It will run for unauth user too.
    dispatch(UserLoginBefore())
    //add service locations to redux
    dispatch(SearchServiceLocations(serviceLocations))
  }, [])
  useRefreshData()
  useSubscribeToEvents()
  return (
    <LayoutProvider>
      <div
        id={id}
        className={classNames}
        aria-live="polite"
        aria-atomic="true"
        style={{ position: "relative", minHeight: 200 }}
      >
        <ModalController>
          <LayoutSearchModal modalTitle="Find a boat by location" />
          <LocationTrack>
            <Tracking>
              <StickyBox className="sticky-header">
                <Header type={headerType} />
              </StickyBox>
              <main className="main-style" id="scrollableDiv">
                {/*{React.cloneElement(children)}*/}
                {children}
              </main>
              {footerType !== "none" && (
                <Footer
                  type={footerType}
                  page={footerPage}
                  serviceLocations={serviceLocations}
                />
              )}
              <Toaster />
            </Tracking>
          </LocationTrack>
        </ModalController>
      </div>
    </LayoutProvider>
  )
}

export default withAppInstalled(Layout)
// Create the context
const LayoutContext = createContext()
// Create the provider component
const LayoutProvider = ({ children }) => {
  const { navRef, navHeight } = useNavHeight() // Use the hook inside the provider
  return (
    <LayoutContext.Provider value={{ navRef, navHeight }}>
      {children}
    </LayoutContext.Provider>
  )
}
// Export the context and provider
export { LayoutProvider, LayoutContext }
